<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <button type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="['btn btn-sm btn-outline-filter btn-sound-reduction', filterUiState('soundReductionIndex', item.value)]"
        v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionSoundReductionIndex',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'R<sub>W</sub> (C;C<sub>tr</sub>) [dB]',
      items: [
        { title: '≥ 43,8', value: 43.8 },
        { title: '≥ 44', value: 44 },
        { title: '≥ 47,6', value: 47.6 },
        { title: '≥ 48,1', value: 48.1 },
        { title: '≥ 48,2', value: 48.2 },
        { title: '≥ 48,4', value: 48.4 },
        { title: '≥ 48,9', value: 48.9 },
        { title: '≥ 50,2', value: 50.2 },
        { title: '≥ 50,4', value: 50.4 },
        { title: '≥ 50,5', value: 50.5 },
        { title: '≥ 50,7', value: 50.7 },
        { title: '≥ 50,9', value: 50.9 },
        { title: '≥ 51', value: 51 },
        { title: '≥ 51,1', value: 51.1 },
        // { title: '≥ 51,2', value: 51.2 },
        { title: '≥ 51,3', value: 51.3 },
        { title: '≥ 51,4', value: 51.4 },
        { title: '≥ 51,5', value: 51.5 },
        { title: '≥ 51,6', value: 51.6 },
        { title: '≥ 51,8', value: 51.8 },
        { title: '≥ 52,5', value: 52.5 },
        { title: '≥ 52,7', value: 52.7 },
        { title: '≥ 53', value: 53 },
        { title: '≥ 53,1', value: 53.1 },
        { title: '≥ 53,4', value: 53.4 },
        { title: '≥ 54', value: 54 },
        { title: '≥ 54,1', value: 54.1 },
        { title: '≥ 54,5', value: 54.5 },
        { title: '≥ 54,8', value: 54.8 },
        { title: '≥ 55,8', value: 55.8 },
        { title: '≥ 58,3', value: 58.3 },
        { title: '≥ 58,7', value: 58.7 },
        { title: '≥ 58,8', value: 58.8 },
        { title: '≥ 59,4', value: 59.4 }, 
        { title: '≥ 59,6', value: 59.6 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('soundReductionIndex', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title.split('<sub>').join('').split('</sub>').join('') + ' ' + title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'soundReductionIndex',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
